import moment from "moment/moment";
import Pikaday from "pikaday";

(function(){
    window.moment = moment;
    window.Pikaday = Pikaday;
})();

// run this to rebuild the file to dist folder
// esbuild src\js\umbracoforms.vendors.js --bundle --minify --outfile=wwwroot\dist\js\umbracoforms.vendors.min.js